import BREADCRUMBS, {
  type Breadcrumb as BreadcrumbData,
} from '../_consts/breadcrumbs';
import type CurrentRouteValues from '../_hooks/useCurrentRoute/types';

export interface Breadcrumb
  extends Omit<BreadcrumbData, 'checkIsValid' | 'getHref'> {
  isValid: boolean;
  href: string;
}

const getBreadcrumbs = (
  currentRoute: CurrentRouteValues | undefined,
): Breadcrumb[] => {
  if (!currentRoute) {
    return [];
  }
  const filteredCrumbs = BREADCRUMBS.filter(
    (crumb) =>
      crumb.isAccessory === currentRoute.isAccessory &&
      crumb.isOuraRing4Wizard === currentRoute.isOuraRing4Wizard,
  );

  const crumbs: Breadcrumb[] = filteredCrumbs.map((crumb) => ({
    title: crumb.title,
    enumVal: crumb.enumVal,
    isValid: crumb.checkIsValid(currentRoute),
    href: crumb.getHref(currentRoute),
  }));

  return crumbs;
};

export default getBreadcrumbs;
